export const setupContent = {
  title: "Zero-Friction Setup: Ready in 12 Minutes",
  lead: "Integration takes 12 minutes. Don't want to dig under the hood yourself? No problem.",
  detail:
    "Our team handles the entire backend: we configure the webhooks, set up the business rules for your specific operations, and deliver a ready turnkey system by the end of the day. Your only job is to check your calendar for new estimates.",
  steps: [
    "Our team configures your custom response rules and assistant (Done For You)",
    "Connect your website form or GoHighLevel CRM (Takes 2 minutes)",
    "Your 26-second Safety Net goes live immediately",
  ],
}

export const setupLabels = ["Step 1", "Step 2", "Step 3"]
